import { FaUsers, FaEnvelopeOpenText } from 'react-icons/fa';
import { ENUM_PERMISSIONS } from '../../../interaces/enums/enums.interface';
export const TABS_USERS = [
  { id: 'USUARIOS', icon: <FaUsers />, permission:ENUM_PERMISSIONS.MOD_USERS_MANAGEMENT_READ},
  { id: 'INVITACIONES', icon: <FaEnvelopeOpenText /> ,permission:ENUM_PERMISSIONS.MOD_USERS_INVITATIONS_READ},
];
export const TABS_USERS_ENUM = {
  USERS: 'USUARIOS',
  INVITATIONS: 'INVITACIONES',
};

export const ROLE_LABEL = {
  SUPERADMIN: 'Super Admin',
  DIRECTOR: 'Director',
  GOVERNMENT_OFFICIAL: 'Funcionario',
  CITIZEN: 'Ciudadano',
  COLLABORATOR: 'Colaborador',
};


export const STATUS_INVITATIONS = [
  {
    value: 'CANCELLED',
    key: 'CANCELLED',
  },
  {
    value: 'PENDING',
    key: 'PENDING',
  },
  {
    value: 'EXPIRED',
    key: 'EXPIRED',
  },
  {
    value: 'ACCEPTED',
    key: 'ACCEPTED',
  },
];
